(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["preorder-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('preorder-notice')) {
    customElements.define(
      'preorder-notice',
      class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section, dialog');
          this.section?.addEventListener('variant:update', this.update);
        }

        disconnectedCallback() {
          this.section?.removeEventListener('variant:update', this.update);
        }

        update = (event) => {
          const data = event.detail?.data;
          if (!data?.html) return;
          if (!data.newProduct && data.productId && data.productId !== this.dataset.productId) return;

          const next = data.html.querySelector(`preorder-notice[data-block-id="${this.dataset.blockId}"]`);
          if (next) this.innerHTML = next.innerHTML;
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
